/** Require private build configuration without including its value in errors. */
export function requireSyncfusionLicense(value: unknown): string {
  if (typeof value !== "string" || value.trim().length === 0) {
    throw new Error(
      "VITE_SYNCFUSION_LICENSE is required. Configure it privately before building or starting SofyApps.",
    );
  }
  return value.trim();
}
